import React from "react";
import PropTypes from "prop-types";
import { base_path } from "../../environment";

const ImageWithBasePath = (props) => {
  // Define fallback images based on context
  const fallbackImages = {
    product: "https://odabill.com/assets/img/products/phone-add-1.png",
    category: "https://odabill.com/assets/img/products/pos-product-04.png",
    customer: "https://odabill.com/assets/img/customer/no-imagecustomer.png",
    supplier: "https://odabill.com/assets/img/supplier/no-imagesupplier.png",
    default: "https://odabill.com/assets/img/default/no-image.png",
  };

  // Determine fallback based on context prop
  const fallbackImage = fallbackImages[props.context] || fallbackImages.default;

  // Handle src: extract first URL from array, use fallback if invalid
  let src = props.src;
  if (Array.isArray(props.src) && props.src.length > 0) {
    src = props.src[0]; // Use first image URL from array
  }

  const fullSrc = typeof src === "string" && src
    ? src.startsWith("blob:") ||
      src.startsWith("data:") ||
      src.startsWith("http://") ||
      src.startsWith("https://")
      ? src
      : `${base_path}${src}`
    : fallbackImage;

  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt || "Image"}
      width={props.width}
      id={props.id}
      onError={(e) => console.error("Image failed to load:", fullSrc, e)}
    />
  );
};

ImageWithBasePath.propTypes = {
  className: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  alt: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
  context: PropTypes.oneOf(["product", "category", "customer", "supplier", "default"]),
};

ImageWithBasePath.defaultProps = {
  src: null,
  alt: "Image",
  context: "default",
};

export default ImageWithBasePath;